import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiTablesComponent } from './ui-tables.component';
import { UiUsersComponent } from './users/ui-users/ui-users.component';
import {CardModule} from "../../../resources/components/card/card.module";
import {SmartTableModule} from "../../../resources/modules/smart-table/smart-table.module";
import {RouterModule} from "@angular/router";
import {SharedModule} from "../../../modules/shared.module";
import { UiUserStoresComponent } from './users/ui-user-stores/ui-user-stores.component';
import { UiUserPurchasesComponent } from './users/ui-user-purchases/ui-user-purchases.component';
import { UiUserProjectsComponent } from './users/ui-user-projects/ui-user-projects.component';
import { UiUserDevicesComponent } from './users/ui-user-devices/ui-user-devices.component';
import {IconsModule} from "../../../resources/components/icons/icons.module";
import { UiProductsComponent } from './products/ui-products/ui-products.component';
import {ReducerPipeModule} from "../../../resources/pipes/reducer-pipe/reducer-pipe.module";
import {NgxPopperModule} from "ngx-popper";
import { UiPurchasesComponent } from './purchases/ui-purchases/ui-purchases.component';
import { UiProjectsComponent } from './projects/ui-projects/ui-projects.component';
import {BadgeExistModule} from "../../../resources/components/badge-exist/badge-exist.module";
import { UiProjectVersionsComponent } from './projects/ui-project-versions/ui-project-versions.component';
import { UiStoreGroupsComponent } from './store-groups/ui-store-groups/ui-store-groups.component';
import { UiModeratorsComponent } from './moderators/ui-moderators/ui-moderators.component';
import { UiStoresComponent } from './stores/ui-stores/ui-stores.component';
import { UiStoreProjectsComponent } from './stores/ui-store-projects/ui-store-projects.component';
import { UiStoreUsersComponent } from './stores/ui-store-users/ui-store-users.component';
import { UiStoreProductsComponent } from './stores/ui-store-products/ui-store-products.component';
import { UiStoreCollectionsComponent } from './stores/ui-store-collections/ui-store-collections.component';
import { UiStoreActionsComponent } from './stores/ui-store-actions/ui-store-actions.component';
import { UiStoreVersionsComponent } from './stores/ui-store-versions/ui-store-versions.component';
import {FormsModule} from "@angular/forms";
import {CheckInputModule} from "../../../resources/components/check-input/check-input.module";
import {UpperFirstPipeModule} from "../../../resources/pipes/upper-first-pipe/upper-first-pipe.module";



@NgModule({
  declarations: [
    UiTablesComponent,
    UiUsersComponent,
    UiUserStoresComponent,
    UiUserPurchasesComponent,
    UiUserProjectsComponent,
    UiUserDevicesComponent,
    UiProductsComponent,
    UiPurchasesComponent,
    UiProjectsComponent,
    UiProjectVersionsComponent,
    UiStoreGroupsComponent,
    UiModeratorsComponent,
    UiStoresComponent,
    UiStoreProjectsComponent,
    UiStoreUsersComponent,
    UiStoreProductsComponent,
    UiStoreCollectionsComponent,
    UiStoreActionsComponent,
    UiStoreVersionsComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    SmartTableModule,
    RouterModule,
    SharedModule,
    IconsModule,
    ReducerPipeModule,
    NgxPopperModule,
    BadgeExistModule,
    FormsModule,
    CheckInputModule,
    UpperFirstPipeModule
  ]
})
export class UiTablesModule { }
